<div class="add-page">
  <div class="add-page__header">
    <div class="header-link-block">Add Offer</div>
  </div>
  <div class="add-page__content">
    <input-cmp
      class="title-input"
      [inputText]="offerUrl"
      isAdd="true"
      [isEdit]="isEdit"
      placeholder="Offer Url"
      (output)="setUrl($event)"
    ></input-cmp>
    <input-cmp
      isUpload="true"
      placeholder="Upload Image"
      (output)="imageFileOutput($event)"
    ></input-cmp>
  </div>
  <div
    [style.grid-template-columns]="'15rem' + ' ' + '!important'"
    class="add-page__buttons"
  >
    <button-cmp
      isLogin="false"
      isAdd="false"
      isCancel="false"
      [title]="add"
      (click)="onAddClick()"
    ></button-cmp>
  </div>
</div>
